export default __webpack_public_path__ + "static/media/use-case-sales-master-data.b0e319ae.gif";